import { useState } from "react"
import axios from 'axios';
import {  useNavigate } from 'react-router-dom';
import language from '../../variables/language';


export default function Select({options, info, handleInputChange, fieldName, disabled, value, inputName, ...props }) {
    
    const [input,setInput] = useState({'name' : inputName, 'value' :  0});


    return (
        <select name={inputName} key={inputName}  value={value} disabled={disabled}
        onChange={ (e) => handleInputChange( e.target.value, input.name ) } className={props.className} >
        
            <option className=' from-option txt-c' >{info}</option>
            {options.length > 0 ? (
            options.map(item => (
                <option className='from-option txt-c' key={item['id']+'option'}
                    value={item['id']}>{ language[language.lang][item[fieldName]] ? language[language.lang][item[fieldName]]  : item[fieldName] }</option>
            ))
            ) : (
            <option> {language[language.lang]['Empty list']} </option>
            )}
        </select>
    )
}


